export default "__VITE_ASSET__CulDIAOc__"